import script from "./LinkStoreroom.vue?vue&type=script&setup=true&lang=js"
export * from "./LinkStoreroom.vue?vue&type=script&setup=true&lang=js"

import "./LinkStoreroom.vue?vue&type=style&index=0&id=627ffd6f&lang=scss"

const __exports__ = script;

export default __exports__